/**
 * Returns true if the value is an object which as a property with the given
 * name with a value other than `undefined`.
 */
export function hasProperty<Property extends PropertyKey>(
    value: unknown,
    name: Property,
): value is Record<Property, unknown> {
    return (
        typeof value === 'object' &&
        value !== null &&
        name in value &&
        (value as Record<Property, unknown>)[name] !== undefined
    );
}

export function isEmpty(value: unknown): boolean {
    return (
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && isEmptyObject(value))
    );
}

export function isEmptyObject(value: object): boolean {
    return !Object.values(value).some((x) => !isEmpty(x));
}
